<div class="c-block c-block--bordered">
  <dl class="c-detail__list">
    <dt class="c-detail__list-name">Additional Loan Details</dt>
    <dt class="c-detail__list-title">Date loan required</dt>
    <dd class="c-detail__list-description">{{DateLoanRequired}}</dd>
    <dt class="c-detail__list-title">How are you going to repay the outstanding balance at the end of your term?</dt>
    <dd class="c-detail__list-description">{{RepaymentStrategy}}</dd>
  </dl>
  @if (HasAdditionalSecurity) {
    <h6>Additional security</h6>
    <dl class="c-detail__list">
      <dt class="c-detail__list-title">What’s the purpose of the property?</dt>
      <dd class="c-detail__list-description">{{PropertyCategory}}</dd>
      <dt class="c-detail__list-title">What type of property is it?</dt>
      <dd class="c-detail__list-description">{{PropertyType}}</dd>
      <dt class="c-detail__list-title">Address</dt>
      <dd class="c-detail__list-description">{{Address}}</dd>
      <dt class="c-detail__list-title">What's the value of the property?</dt>
      <dd class="c-detail__list-description">{{Valuation}}</dd>
      <dt class="c-detail__list-title">What did you originally pay for it?</dt>
      <dd class="c-detail__list-description">{{PurchasePrice}}</dd>
      <dt class="c-detail__list-title">Purchase Date</dt>
      <dd class="c-detail__list-description">{{PurchaseDate}}</dd>
    </dl>
    <ng-container>
      @if (HasExistingCharges) {
        <div>
          <h6>Existing charges</h6>
          <dl class="c-detail__list">
            <dt class="c-detail__list-title">How much is outstanding on your mortgage?</dt>
            <dd class="c-detail__list-description">{{ExistingChargeValue}}</dd>
            <dt class="c-detail__list-title">Which company is your mortgage with?</dt>
            <dd class="c-detail__list-description">{{ExistingChargeCompany}}</dd>
          </dl>
        </div>
      }
      @if (HasSecuredDebt) {
        <div>
          <h6>Other secured debt</h6>
          <dl class="c-detail__list">
            <dt class="c-detail__list-title">How much is outstanding on these additional loans?</dt>
            <dd class="c-detail__list-description">{{SecuredDebtValue}}</dd>
          </dl>
        </div>
      }
    </ng-container>
  }
  @if (showEditButton) {
    <button class="c-button c-button--neutral" type="button" (click)="editButtonClicked()">
      Edit additional details
      <svg class=" c-button__icon c-button__icon--right icon-arrow-right " aria-hidden="true " focusable="false " xmlns="http://www.w3.org/2000/svg " viewBox="0 0 8.06 14.71 "><path fill="none " stroke="#2f3432 " stroke-miterlimit="10 " d="M.35 14.35l7-7-7-7 " /></svg>
    </button>
  }
</div>
